const VideoIframe = (target) => {
  const initVideoIframe = el => {
    el.addEventListener('click', e => {
      const target = e.currentTarget
      const html = target.dataset.video
      // eslint-disable-next-line no-undef
      swal.fire({
        html,
        showCloseButton: true,
        closeButtonHtml: '<i class="icon icon-close"></i>',
        showConfirmButton: false,
      })
    })
  };

  $('body').find(target)
    .each((_, el) => {
      initVideoIframe(el);
    });
}

export default VideoIframe;



// WEBPACK FOOTER //
// ./scripts/components/VideoIframe.js